// extracted by mini-css-extract-plugin
module.exports = {"recipe":"recipe_recipe__2bqls","image":"recipe_image__2iN0q","calories":"recipe_calories__2tgI-"};